function monthlyPrice(plans) {
    var _a, _b;
    if (!plans)
        return null;
    const monthly = plans.find(p => (p === null || p === void 0 ? void 0 : p.kind) === 'MONTHLY');
    if (((_a = monthly === null || monthly === void 0 ? void 0 : monthly.price) === null || _a === void 0 ? void 0 : _a.amount) != null)
        return monthly.price.amount;
    const annual = plans.find(p => (p === null || p === void 0 ? void 0 : p.kind) === 'ANNUAL');
    if (((_b = annual === null || annual === void 0 ? void 0 : annual.price) === null || _b === void 0 ? void 0 : _b.amount) != null)
        return annual.price.amount / 12;
    return null;
}
export function useAddBenefitToTiers({ client, currentBusinessId, sourceTier, benefitId, benefitTypename }) {
    const noun = (sourceTier === null || sourceTier === void 0 ? void 0 : sourceTier.isSubscription) ? 'subscriptions' : 'memberships';
    const targets = (() => {
        var _a;
        const list = ((_a = sourceTier === null || sourceTier === void 0 ? void 0 : sourceTier.business) === null || _a === void 0 ? void 0 : _a.membershipTiers) || [];
        return list
            .filter((t) => !!t && t.id !== sourceTier.id)
            .filter(t => (typeof t.isSubscription === 'boolean' ? t.isSubscription === !!sourceTier.isSubscription : true))
            .map(t => ({ id: t.id, name: t.name || '', priceMonthly: monthlyPrice(t.plans) }));
    })();
    const addTo = (mode, targetId) => {
        const currentPrice = monthlyPrice(sourceTier === null || sourceTier === void 0 ? void 0 : sourceTier.plans);
        client.cache.modify({
            id: `Business:${currentBusinessId}`,
            fields: {
                membershipTiers(existingTiers = [], { storeFieldName, readField }) {
                    if (!storeFieldName.includes('"kind":"Live"'))
                        return existingTiers;
                    existingTiers.forEach((tierRef) => {
                        const tierId = readField('id', tierRef);
                        if (!tierId || tierId === sourceTier.id)
                            return;
                        const isSub = readField('isSubscription', tierRef);
                        if (typeof isSub === 'boolean' && isSub !== !!sourceTier.isSubscription)
                            return;
                        if (mode === 'single' && tierId !== targetId)
                            return;
                        if (mode === 'higher') {
                            const plans = readField('plans', tierRef);
                            const price = monthlyPrice(plans || null);
                            // Include equal-priced tiers as "higher" per product spec
                            if (!price || !currentPrice || price < currentPrice)
                                return;
                        }
                        client.cache.modify({
                            id: tierRef.__ref,
                            fields: buildFieldModifiers({ client, benefitId, benefitTypename, readField })
                        });
                    });
                    return existingTiers;
                }
            }
        });
    };
    return { noun, targets, addTo };
}
function buildFieldModifiers({ client, benefitId, benefitTypename, readField }) {
    const benefitCacheId = client.cache.identify({ __typename: benefitTypename, id: benefitId });
    const benefitRef = benefitCacheId ? { __ref: benefitCacheId } : null;
    const addToBenefits = (existing = []) => {
        if (!benefitRef)
            return existing;
        const list = Array.isArray(existing) ? existing.filter(Boolean) : [];
        if (list.some(r => r.__ref === benefitCacheId))
            return list;
        return [...list, benefitRef];
    };
    if (benefitTypename === 'RegularBenefit') {
        return { benefits: addToBenefits };
    }
    if (benefitTypename === 'WelcomeGiftBenefit') {
        return {
            benefits: addToBenefits,
            welcomeGift(existing = null) {
                if (!benefitRef)
                    return existing;
                const already = !!existing;
                if (already)
                    return existing;
                return benefitRef;
            }
        };
    }
    if (benefitTypename === 'RedemptionBenefit') {
        return {
            benefits: addToBenefits,
            redemptionBenefit(existing = null) {
                if (!benefitRef)
                    return existing;
                const already = !!existing;
                if (already)
                    return existing;
                return benefitRef;
            }
        };
    }
    // SubscriptionBenefit
    return {
        benefits(existing = [], { readField: rf }) {
            const list = Array.isArray(existing) ? existing.filter(Boolean) : [];
            // Skip if this tier already has any SubscriptionBenefit
            const hasSub = list.some(ref => rf('__typename', ref) === 'SubscriptionBenefit');
            if (hasSub)
                return list;
            if (!benefitRef)
                return list;
            if (list.some(r => r.__ref === benefitCacheId))
                return list;
            return [...list, benefitRef];
        },
        subscriptionBenefits(existing = []) {
            if (!benefitRef)
                return existing;
            const list = Array.isArray(existing) ? existing.filter(Boolean) : [];
            if (list.some(r => r.__ref === benefitCacheId))
                return list;
            return [...list, benefitRef];
        },
        subscriptionBenefit(existing = null) {
            if (!benefitRef)
                return existing;
            return benefitRef;
        }
    };
}
